import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'dda-scroll-icon',
  styleUrl: 'dda-scroll-icon.css',
  shadow: true,
})
export class DdaScrollIcon {
  @Prop() scroll_icon_size?: string = '';
  @Prop() scroll_icon_color?: string = '';
  @Prop() custom_class: string = '';
  @Prop() component_mode: string = '';

  render() {
    const scrollIconClass = [
      'dda-scroll-icon-scroll',
      this.scroll_icon_size ? `scroll-icon-size-${this.scroll_icon_size}` : '',
      this.scroll_icon_color ? `scroll-icon-color-${this.scroll_icon_color}` : '',
      this.component_mode,
    ].filter(Boolean).join(' ');


    return (
      <div class={scrollIconClass}>
        <div class="dda-scroll-icon-scroll-dot"></div>
      </div>
    );
  }
}